import * as React from "react";
import { children, elementHelper, classComponents } from "../api-data";
import { ExternalLink } from "../links";
import { VerticalGroup } from "../vertical-group";
import { height } from "../zoom-container";
import { CategoryTitle } from "./category-title";

export function Legacy({  }) {
  const rectWidth = 570;
  const rectHeight = 550;

  const x = 2600;
  const y = height * (1 / 2) - rectHeight / 2;

  return (
    <g id="legacy" transform={`translate(${x},${y})`}>
      <CategoryTitle>Legacy</CategoryTitle>
      <text y={-8} x={135} fontSize={14}>
        These are not recommended for use in newly written code. See{" "}
        <ExternalLink href="https://beta.reactjs.org/reference/react/legacy">
          Legacy React APIs
        </ExternalLink>
        .
      </text>
      <rect
        x={0}
        y={0}
        rx={16}
        id="legacy"
        width={rectWidth}
        height={rectHeight}
        strokeWidth={1}
        stroke="dimgray"
        fill="hsl(0deg 0% 97%)"
        filter="url(#shadow)"
      />
      <foreignObject height={children.size * 100} width={280} x={20} y={20}>
        <VerticalGroup
          data={classComponents}
          name="Class Components"
          isDisabled
        />
      </foreignObject>

      <foreignObject
        height={elementHelper.size * 100 + 10}
        width={280}
        x={20}
        y={320}
      >
        <VerticalGroup data={elementHelper} name="Element Helpers" isDisabled />
      </foreignObject>

      <foreignObject height={children.size * 100} width={280} x={300} y={20}>
        <VerticalGroup data={children} name="Children" isDisabled />
      </foreignObject>
    </g>
  );
}
